import React from 'react';
import SvgIconDPC from "../dpc-svg-icon";

export default class LanguageButtonDPC extends React.Component {

    selectedLanguage = typeof window !== `undefined` ? (this.props.lang === 'it' ? 'ITA' : 'ENG') : null;

    getPathLanguage = (lingua, slug) => {
        this.selectedLanguage = lingua === 'it' ? 'ITA' : 'ENG';
        if (slug) {
            slug = slug.charAt(0) === '/' ? `${slug.slice(1)}` : slug;
            if (typeof window !== `undefined` ? (window.location.pathname.split("/")[1] !== lingua) : null) {
                return `/${lingua}/${slug}`;
            } else if (typeof window !== `undefined` ? (window.location.pathname.split("/")[1] === lingua) : null) {
                return `${typeof window !== `undefined` ? window.location.pathname : null}/`;
            }
        } else {
            return `/${lingua}/`;
        }
    };

    render() {
        return (
            <div className="it-header-slim-wrapper">
                <div className="container">
                    <div className="it-header-slim-wrapper-content">
                        <a href="#main" className="sr-only sr-only-focusable">Vai al contenuto principale</a>

                        <a href="#footer" className="sr-only sr-only-focusable">Raggiungi il piè di pagina</a>

                        <div className="it-header-slim-right-zone ml-auto">                  
                            <div className="it-socials d-none d-xl-flex"> 
                                <ul className="marginCustomLangButtAD">    
                             
                                    <li className="marginCustomLiAD">
                                                        
                                        <a href="https://www.tiktok.com/@attimodecisivo?_t=ZN-8xszCgoxDDq&_r=1"
                                            title="Segui la campagna di Attimo decisivo su TikTok"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'tiktok'} color={"#475047"} className={'customIconTTLangButtonAD'} />
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.instagram.com/attimodecisivo/?igsh=MWcxd2lkNGZsZDRnYQ%3D%3D"
                                            title="Profilo della campagna Attimo decisivo su Instagram"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'instagram'} color={"#475047"}/>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.youtube.com/@attimodecisivo"
                                            title="Canale YouTube della campagna Attimo decisivo"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'youtube'} color={"#475047"}/>
                                        </a>
                                    </li>
                                                                            
                                          
                                </ul>  
                            </div>

                            <div className="nav-item dropdown lang-selector">
                                <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
                                   aria-expanded="false">
                                    <span>{this.selectedLanguage}</span>

                                    <SvgIconDPC name='expand' aria-hidden="true" color={"#475047"}/>
                                </a>

                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="link-list-wrapper">
                                                <ul className="link-list">
                                                    <li><a className="list-item" href='#' onClick={() =>
                                                        typeof window !== `undefined` ? (window.location.pathname = this.getPathLanguage(
                                                            'it',
                                                            this.props.slugTraduzione
                                                        )) : null
                                                    }
                                                    ><span>ITA</span></a></li>

                                                    <li><a className="list-item" href='#' onClick={() =>
                                                        typeof window !== `undefined` ? (window.location.pathname = this.getPathLanguage(
                                                            'en',
                                                            this.props.slugTraduzione
                                                        )) : null
                                                    }
                                                    ><span>ENG</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
